import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { t } from 'ttag';
import { useQuery } from '@apollo/react-hooks';
import Avatar from '../Avatar';
import FormBox from '../FormBox';
import useApi from '../../api';

const AthleteViewDialog = ({ objId }) => {
  const api = useApi();
  const [oneQuery, oneKey] = api.schema.athletes.one();

  const { loading, data } = useQuery(oneQuery, {
    variables: { id: objId },
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return (
      <Backdrop open>
        <CircularProgress />
      </Backdrop>
    );
  }

  const res = data[oneKey];
  return (
    <Paper>
      <FormBox title={res.fullName}>
        <Grid container justify='center' alignItems='center'>
          <Grid item>
            <Avatar src={res.photo && res.photo.url} size='large' />
          </Grid>
        </Grid>
        <Grid
          container
          direction='column'
          justify='flex-start'
          alignItems='flex-start'
        >
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`Дата народження: `}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.birthday}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`Email:`}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.email}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`Телефон:`}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.phone}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`Кю/Дан:`}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.rank}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`Спортивна кваліфікація:`}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.qualification}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='subtitle2' gutterBottom>
              {t`WKF-ID:`}
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              {res.leagueId}
            </Typography>
          </Grid>
        </Grid>
      </FormBox>
    </Paper>
  );
};

export default AthleteViewDialog;
